import { PureComponent } from 'react'
import PropTypes from 'prop-types'

class ExpansionPanelSummary extends PureComponent {
  render() {
    return this.props.children
  }
}

ExpansionPanelSummary.propTypes = {
  children: PropTypes.node
}
ExpansionPanelSummary.defaultProps = {
  children: undefined
}

export default ExpansionPanelSummary
